module.exports = __webpack_public_path__ + "_assets/img/scan-a.93a923b4.svg";